import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* paymentRefundCheck(action: ActionInterface): any {
  try {
    yield put({
        type: Constants.GLOBAL_PAYMENT_REFUND_REQUEST
      })

    yield call(Http.get, `payments/${action.payload?.payment?.id}/refundScenario`);

    yield put({
        type: Constants.GLOBAL_PAYMENT_REFUND_SUCCESS
      })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_REFUND_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentRefundCheck() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_REFUND_CHECK_START, paymentRefundCheck);
}
